export default () => ({
  root: {
    height: "100%",
    display: "flex",
    flexFlow: "column",
  },
  weekDays: {
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoFlow: "column",
    boxSizing: "border-box",
    border: "1px solid #EEE",
    background: "#FFF",
    height: 40,
  },
  placeCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  weekDay: {
    color: "#999999",
    fontFamily: "'Open Sans', sans-serif",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
  },
  days: {
    display: "grid",
    gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
    gridTemplateRows: "repeat(4, minmax(0, 1fr))",
    flex: 1,
  },
  dayWrapper: {
    border: "1px solid #EEE",
    background: "#FFF",
    position: "relative",
    height: 210,
  },
  date: {
    position: "absolute",
    top: 12,
    width: "100%",
    color: "#333",
    fontSize: 12,
    lineHeight: "18px",
    textAlign: "center",
    fontFamily: "'Open Sans', sans-serif",
  },
  singleEntryWrapper: {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    background: "#F9F9F9",
  },
  singleEntryTitle: {
    color: "#000",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    width: "80%",
  },
  singleEntryTime: {
    color: "#000",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "center",
    fontSize: 12,
    lineHeight: "18px",
    width: "80%",
    marginTop: 8,
  },
  singleEntryStatusBox: {
    padding: 5,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: 0,
  },
  singleEntryStatus: {
    color: "#FFF",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "center",
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
  },
  singleEntryActionsWrapper: {
    position: "absolute",
    top: 0,
    bottom: -1,
    left: -1,
    right: -1,
    backdropFilter: "blur(50px)",
    background: "rgba(255, 255, 255, 0.9)",
    padding: 16,
    flexFlow: "column",
    alignItems: "flex-start",
    justifyContent: "space-evenly",
  },
  singleEntryButtonWrapper: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "100%",
    "&:hover": {
      "& svg": {
        stroke: "#26BBED !important",
      },
      "& p": {
        color: "#26BBED !important",
      },
    },
  },
  singleEntryNegButtonWrapper: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "100%",
    "&:hover": {
      "& svg": {
        stroke: "#E75F5F !important",
      },
      "& p": {
        color: "#E75F5F !important",
      },
    },
  },
  buttonText: {
    color: "#333",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "center",
    fontSize: 14,
    lineHeight: "20px",
    marginLeft: 4,
    display: 'flex',
    justifyContent: 'space-between',
    width: "93%",
    "&:hover": {
      color: "#26BBED",
    },
    "&:hover path": {
      stroke: "#26BBED",
    },
  },
  editIcon: {
    width: 16,
    height: 16,
    fill: "none",
    stroke: "#333",
  },
  duplicateIcon: {
    width: 15,
    height: 17,
    fill: "none",
    stroke: "#333",
  },
  previewIcon: {
    width: 18,
    height: 12,
    fill: "none",
    stroke: "#333",
  },
  cancelIcon: {
    width: 18,
    height: 18,
    fill: "none",
    stroke: "#333",
  },
  archiveIcon: {
    width: 14,
    height: 14,
    fill: "none",
    stroke: "#333",
  },
  publishIcon: {
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
  },
  scheduleIcon: {
    width: 24,
    height: 24,
    fill: "none",
    stroke: "#333",
  },
  multipleEntriesWrapper: {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: 38,
    width: "100%",
    background: "#FFF",
  },
  multipleEntriesItemBox: {
    borderLeft: "6px solid #333",
    height: 30,
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginBottom: 8,
    cursor: "pointer",
  },
  multipleEntriesButtonWrapper: {
    flexFlow: "column",
    width: "auto",
    height: "100%",
    justifyContent: "space-between",
  },
  multipleEntriesButtonText: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: "18px",
  },
  expandBox: {
    height: 34,
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    bottom: 0,
    cursor: "pointer",
    background: "#FFF",
    "&:hover": {
      background:
        "linear-gradient(0deg, rgba(38, 187, 237, 0.06), rgba(38, 187, 237, 0.06)), #FFFFFF",
      "& $expandBoxText": {
        color: "#26BBED",
      },
    },
  },
  expandBoxText: {
    color: "#333",
    fontFamily: "'Open Sans', sans-serif",
    textAlign: "center",
    fontSize: 12,
    lineHeight: "18px",
    fontWeight: 600,
  },
  expandedDisplayDate: {
    margin: "12px 0",
    width: "100%",
    color: "#333",
    fontSize: 14,
    lineHeight: "20px",
    textAlign: "center",
    fontFamily: "'Open Sans', sans-serif",
  },
  popper: {
    zIndex: 2000,
    '&[x-placement*="right"] $arrow': {
      top: "48%",
      left: 0,
      marginLeft: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent #FFF transparent transparent`,
      },
    },
    '&[x-placement*="left"] $arrow': {
      top: "48%",
      right: 0,
      marginRight: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent #FFF`,
      },
    },
  },
  arrow: {
    position: "absolute",
    fontSize: 7,
    width: "3em",
    height: "3em",
    "&::before": {
      content: '""',
      margin: "auto",
      display: "block",
      width: 0,
      height: 0,
      borderStyle: "solid",
    },
  },
  paper: {
    width: 340,
    height: 400,
    maxWidth: 400,
    overflow: "auto",
    boxShadow: "0px 4px 20px rgb(204 204 204)",
    borderRadius: 0,
  },
  detailContentBox: {
    width: "100%",
    height: "100%",
    padding: 12,
    display: "flex",
    flexFlow: "column",
  },
  closeIcon: {
    cursor: "pointer",
    color: "#333",
  },
  recurringEventIcon: {
    position: 'absolute',
    top: 10,
    right: 10
  }
});
